import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import FadeIn from '../components/FadeIn';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Hol van a Cruiser Shop kerékpárüzlet Baján?', acceptedAnswer: { '@type': 'Answer', text: 'A Cruiser Shop kerékpárüzlet Baján található, Bács-Kiskun megyében. Hétfőtől péntekig 8:00–17:00 között várjuk vevőinket.' } },
    { '@type': 'Question', name: 'Van-e kerékpár szerviz Baján?', acceptedAnswer: { '@type': 'Answer', text: 'Igen, a Cruiser Shop teljes körű kerékpár szervizszolgáltatást nyújt Baján: gumicsere, fék- és váltóbeállítás, lánc csere, amortizátor szerviz. Sok esetben még aznap kész a javítás.' } },
    { '@type': 'Question', name: 'Milyen kerékpárokat lehet kapni Baján a Cruiser Shop-nál?', acceptedAnswer: { '@type': 'Answer', text: 'Elektromos kerékpár, túrakerékpár, MTB, városi kerékpár, gyermek kerékpár és háromkerekű kerékpár — összesen 300+ modell, melyeket személyesen is megnézhetsz nálunk.' } },
    { '@type': 'Question', name: 'Honnan érdemes kerékpárt venni Bács-Kiskun megyében?', acceptedAnswer: { '@type': 'Answer', text: 'A Cruiser Shop üzletben Baján — itt személyesen is kipróbálhatod a kerékpárokat, és szakértő segítséget kapsz a választáshoz. Kecskemét, Kiskunfélegyháza, Kalocsa, Bácsbokod és Bácsalmás környékéről is sokan keresnek fel minket.' } },
    { '@type': 'Question', name: 'Mikor van nyitva a kerékpárbolt Baján?', acceptedAnswer: { '@type': 'Answer', text: 'Hétfőtől péntekig 8:00–17:00. Telefonon és emailen is elérhetők vagyunk.' } },
  ],
};

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'BikeStore',
  name: 'Cruiser Shop – Kerékpár Szaküzlet',
  url: 'https://kerekparszakuzletbaja.hu',
  telephone: '+36-70-210-7706',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Baja',
    postalCode: '6500',
    addressCountry: 'HU',
  },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday'], opens: '08:00', closes: '17:00' },
  ],
  areaServed: ['Baja', 'Bács-Kiskun', 'Kalocsa', 'Bácsalmás', 'Bácsbokod', 'Kiskunhalas', 'Kecskemét'],
  priceRange: '$$',
};

export default function KerekparBaja() {
  return (
    <>
      <Helmet>
        <title>Kerékpár Baja – Kerékpárbolt és Szerviz Baján | Cruiser Shop</title>
        <meta name="description" content="Kerékpárüzlet és szerviz Baján. 300+ modell elektromos, túra, MTB, városi és gyermek kerékpár. Cruiser Shop – kerékpár szaküzlet Bács-Kiskun megyében." />
        <link rel="canonical" href="https://kerekparszakuzletbaja.hu/kerekpar-baja" />
        <meta property="og:title" content="Kerékpár Baja – Kerékpárbolt és Szerviz | Cruiser Shop" />
        <meta property="og:description" content="300+ kerékpár modell Baján. Elektromos, túra, MTB, városi, gyermek bringák. Szerviz, beüzemelés, szakértő tanácsadás." />
        <meta property="og:url" content="https://kerekparszakuzletbaja.hu/kerekpar-baja" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
      </Helmet>

      <main className="page">
        {/* Hero */}
        <section style={{ background: 'linear-gradient(135deg, #0D1B2A 0%, #1a3a2a 100%)', padding: 'clamp(48px,8vw,96px) 0 clamp(40px,6vw,72px)' }}>
          <div className="container">
            <nav style={{ marginBottom: 16, fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>
              <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Kezdőlap</Link>
              {' / '}
              <span style={{ color: 'white' }}>Kerékpár Baja</span>
            </nav>
            <FadeIn>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem,5vw,3.5rem)', fontWeight: 900, color: 'white', lineHeight: 1.1, marginBottom: 20 }}>
                Kerékpár Baja –<br /><em style={{ fontStyle: 'italic', color: '#4ade80' }}>Cruiser Shop Szaküzlet</em>
              </h1>
              <p style={{ fontSize: 'clamp(1rem,2vw,1.15rem)', color: 'rgba(255,255,255,0.85)', maxWidth: 680, lineHeight: 1.8, marginBottom: 32 }}>
                Baja és Bács-Kiskun megye legnagyobb kerékpár szaküzlete. 300+ kerékpár modell raktárról — elektromos, túra, MTB, városi és gyermek bringák. Személyes beüzemelés, szakértő tanácsadás és gyors szerviz. Bajáról és Kalocsa, Bácsalmás, Bácsbokod területéről is sokan keresnek minket.
              </p>
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                <Link to="/kerekparok" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#4ade80', color: '#000', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
                  Kerékpárok böngészése
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </Link>
                <Link to="/kapcsolat" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'transparent', border: '2px solid rgba(255,255,255,0.4)', color: 'white', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
                  Elérhetőségek
                </Link>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* Kategóriák */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--bg)' }}>
          <div className="container">
            <h2 className="section-title" style={{ marginBottom: 12 }}>Kerékpár kategóriáink Baján</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: 40, maxWidth: 600 }}>Minden korosztálynak és igénynek megfelelő kerékpárt megtalálsz nálunk, Baján.</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 20 }}>
              {[
                { slug: 'elektromos-kerekpar', label: 'Elektromos kerékpár', desc: '24 modell – e-bike, pedelec', color: '#818cf8' },
                { slug: 'tura-kerekpar', label: 'Túrakerékpár', desc: '90 modell – trekking, hosszútávú', color: '#4ade80' },
                { slug: 'mtb-kerekpar', label: 'MTB kerékpár', desc: '68 modell – mountain bike, hardtail', color: '#86efac' },
                { slug: 'varosi-kerekpar', label: 'Városi kerékpár', desc: '120 modell – city bike, commuter', color: '#fb923c' },
                { slug: 'gyermek-kerekpar', label: 'Gyermek kerékpár', desc: '80 modell – 12–24 col, segédkerekekkel', color: '#fbbf24' },
                { slug: 'haromkereku-kerekpar', label: 'Háromkerekű kerékpár', desc: '6 modell – tricikli, stabil, biztonságos', color: '#c084fc' },
              ].map(c => (
                <Link key={c.slug} to={`/${c.slug}`} style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: '24px', textDecoration: 'none', display: 'block', transition: 'box-shadow .2s' }}>
                  <div style={{ width: 12, height: 12, borderRadius: '50%', background: c.color, marginBottom: 12 }} />
                  <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>{c.label}</h3>
                  <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>{c.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Miért mi */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--white)' }}>
          <div className="container" style={{ maxWidth: 860 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem,3.5vw,2.4rem)', fontWeight: 800, color: 'var(--text)', marginBottom: 16 }}>
              Miért a Cruiser Shop a legjobb kerékpárbolt Baján?
            </h2>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, fontSize: '1.05rem', marginBottom: 32 }}>
              A Cruiser Shop kerékpárüzlet Baján már évek óta kiszolgálja a város és Bács-Kiskun megye kerékpáros igényeit. Több ezer elégedett vásárló bizonyítja, hogy nálunk minőségi kerékpárt, szakértő tanácsadást és megbízható szervizszolgáltatást kapsz.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: 24 }}>
              {[
                { title: '300+ modell', desc: 'Nem kell heteket várni — a legtöbb kerékpár azonnal elvihető.' },
                { title: 'Megbízható minőség', desc: 'Csak olyan modelleket kínálunk, amelyekben mi magunk is megbíznánk.' },
                { title: 'Személyes beüzemelés', desc: 'Szakszerűen beállítjuk, bemutatjuk és átadjuk a kerékpárodat.' },
                { title: 'Gyors szerviz', desc: 'Gumicsere, fékbeállítás, lánc csere — sok esetben még aznap kész.' },
                { title: 'Helyben, Baján', desc: 'Nincs csomagolás, nincs futár — gyere be hozzánk és vidd haza személyesen.' },
                { title: 'Szakértő tanácsadás', desc: 'Segítünk megtalálni a neked legjobb kerékpárt, ingyen és szívesen.' },
              ].map((i, idx) => (
                <FadeIn key={idx}>
                  <div style={{ background: 'var(--bg)', borderRadius: 12, padding: '20px 24px' }}>
                    <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1rem', fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>{i.title}</h3>
                    <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', lineHeight: 1.6 }}>{i.desc}</p>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </section>

        {/* Szerviz */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--bg)' }}>
          <div className="container" style={{ maxWidth: 860 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.4rem,3vw,2rem)', fontWeight: 800, color: 'var(--text)', marginBottom: 16 }}>
              Kerékpár szerviz Baján
            </h2>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, fontSize: '1.05rem', marginBottom: 24 }}>
              A Cruiser Shop teljes körű kerékpár szervizszolgáltatást nyújt Baján. Nem számít a márka vagy a típus — hozzuk rendbe a bringádat! Leggyakoribb szerviz munkák: defektjavítás és gumicsere, fék- és váltóbeállítás, lánc és hajtómű csere, kerék-centrálás, amortizátor szerviz, elektromos kerékpár akkumulátor és motor szerviz. Foglalj időpontot telefonon: <strong>+36 70 210 7706</strong>.
            </p>
            <Link to="/szolgaltatasaink" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, border: '2px solid var(--primary)', color: 'var(--primary)', fontWeight: 700, padding: '12px 24px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
              Összes szolgáltatás megtekintése
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </Link>
          </div>
        </section>

        {/* FAQ */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--white)' }}>
          <div className="container" style={{ maxWidth: 860 }}>
            <h2 className="section-title" style={{ marginBottom: 40 }}>Kerékpár Baja – Gyakori kérdések</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {faqSchema.mainEntity.map((f, i) => (
                <FadeIn key={i}>
                  <details style={{ background: 'var(--bg)', borderRadius: 12, border: '1px solid var(--border)', padding: '20px 24px', cursor: 'pointer' }}>
                    <summary style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--text)', listStyle: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                      {f.name}
                      <span style={{ fontSize: 20, color: '#4ade80', flexShrink: 0 }}>+</span>
                    </summary>
                    <p style={{ marginTop: 12, color: 'var(--text-muted)', lineHeight: 1.7, fontSize: '0.97rem' }}>{f.acceptedAnswer.text}</p>
                  </details>
                </FadeIn>
              ))}
            </div>
          </div>
        </section>

        {/* Nyitvatartás + CTA */}
        <section style={{ background: 'linear-gradient(135deg, #0D1B2A 0%, #1a3a2a 100%)', padding: 'clamp(48px,6vw,80px) 0', textAlign: 'center' }}>
          <div className="container">
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem,4vw,2.4rem)', fontWeight: 800, color: 'white', marginBottom: 12 }}>
              Látogass el hozzánk Baján!
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.05rem', marginBottom: 8 }}>Nyitvatartás: Hétfőtől péntekig 8:00–17:00</p>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.05rem', marginBottom: 32 }}>Telefon: <a href="tel:+36702107706" style={{ color: '#4ade80', textDecoration: 'none', fontWeight: 700 }}>+36 70 210 7706</a></p>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/kerekparok" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#4ade80', color: '#000', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
                Kerékpárok böngészése
              </Link>
              <Link to="/kviz" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'transparent', border: '2px solid rgba(255,255,255,0.4)', color: 'white', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
                Kerékpár kvíz
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
